import { cva, type VariantProps } from 'class-variance-authority';
import type { HTMLAttributes } from 'react';

import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold',
  {
    variants: {
      variant: {
        default: 'bg-[var(--bg-hover)] text-[var(--text-secondary)]',
        draft: 'bg-[var(--accent-amber-subtle)] text-[var(--accent-amber)]',
        review: 'bg-[var(--accent-purple-subtle)] text-[var(--accent-purple)]',
        approved: 'bg-[var(--accent-green-subtle)] text-[var(--accent-green)]',
        sent: 'bg-[var(--accent-cyan-subtle)] text-[var(--accent-cyan)]',
        danger: 'bg-[var(--accent-red-subtle)] text-[var(--accent-red)]',
        accent: 'bg-[var(--accent-subtle)] text-[var(--accent)]',
      },
    },
    defaultVariants: { variant: 'default' },
  },
);

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant, className }))} {...props} />;
}
